// removed by extract-text-webpack-plugin
module.exports = {"label":"src-workpieces----workpieces-module---label---76VYn","thumbnails":"src-workpieces----workpieces-module---thumbnails---3NNVV","thumbnailWrapper":"src-workpieces----workpieces-module---thumbnailWrapper---1EzKt","thumbnail":"src-workpieces----workpieces-module---thumbnail---2pWMu","viewer":"src-workpieces----workpieces-module---viewer---3OVKX","viewerImageWrapper":"src-workpieces----workpieces-module---viewerImageWrapper---2yCY5"};


//////////////////
// WEBPACK FOOTER
// ./src/workpieces/workpieces.module.scss
// module id = 264
// module chunks = 11588923914802